export const host='https://api.wakool.academy/'
export const shareHost='https://share.wakool.academy/'
// export const host='http://localhost:8000/'
